import type {KeyTextField} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import type {
  BookDemoSectionSliceDirectMailPrimaryAssetSectionItem,
  BookDemoSectionSliceDirectMailPrimaryBadgesItem,
} from 'prismicio-types'
import {ButtonV2} from 'src/common/ButtonV2'

export const AssetSection = ({
  assetSection,
  badges,
  ratingsTitle,
  continueHandler,
  continueLabel,
  pageUid = '',
}: {
  assetSection?: BookDemoSectionSliceDirectMailPrimaryAssetSectionItem
  badges?: BookDemoSectionSliceDirectMailPrimaryBadgesItem[]
  ratingsTitle: KeyTextField
  continueHandler: VoidFunction
  continueLabel: KeyTextField
  pageUid?: string
}) => (
  <div className="flex min-h-full w-full flex-col items-center justify-center gap-6 md:mx-auto xl:max-w-[600px]">
    <PrismicNextImage field={assetSection?.image} className="h-auto w-2/3 place-self-center pb-10 lg:w-1/2" />
    <div className="flex w-full flex-col gap-9 border-y-[1px] border-dashed border-grey-150 px-3 pb-6 pt-4">
      <p className="text-body text-center text-moss-white">{ratingsTitle}</p>
    </div>
    <div className="flex gap-4 self-center">
      {badges?.map((rating, index) => (
        <PrismicNextImage field={rating.badge} key={index} className="h-20 max-h-20 w-min lg:h-30 lg:max-h-30" />
      ))}
    </div>
    <ButtonV2
      trackingData={{
        mktgId: 'book-demo-mobile-direct-mail',
        location: 'asset-section',
        dataType: 'continue-button',
        pageName: pageUid,
      }}
      variant="primary"
      className="md:hidden"
      onClick={continueHandler}
    >
      {continueLabel}
    </ButtonV2>
  </div>
)
